import { ErrorHandler, NgModule, inject } from '@angular/core';
import {TrackingService, TrackingErrorHandler} from './tracking.service';

@NgModule({
    providers: [
        TrackingService,
        {
            provide: ErrorHandler,
            useClass: TrackingErrorHandler
        }
    ]
})
export class TrackingModule {
    private trackingService = inject(TrackingService);


    constructor() {
        this.trackingService.init();
    }

}
